module.exports = __webpack_public_path__ + "img/about-background.9787d75b.png";